import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateBasicEmailAddress = mutatorAction('updateBasicEmailAddress', function (emailAddress) {
    var store = connectedAccountsStore();
    store.connectBasicState.emailAddress = emailAddress;
});
//# sourceMappingURL=updateBasicEmailAddress.js.map